// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:29:02Z                      #

// ##############################################################

import ErrorApi from "./../../../utils/ErrorApi";
import Fetch from "./../../../utils/Fetch";
import ParamsFetch from "./../../../utils/ParamsFetch";
import JsonFetch from "./../../../utils/JsonFetch";
import generateUrl from './../../../utils/generateUrl';

import * as UpdateMethods from "./UpdateMethods";

/**
 * Service pro práci s typy dokumentu. Generated from cz.marbes.api.dokument.TypDokumentService.
 */
export default class TypDokumentApi {
    /**
     * Vrací typ dokumentu s předanýcm kódem.
     *
     * @param kodTypDokument 
     * @return {@link TypDokument}
     */
    static getTypDokumentByKod(kodTypDokument : string) : Promise<TypDokument> {
        const uri = serverContextPath + `/api/typy/dokumentu/`;
        const headers = undefined;
        const params = { kodTypDokument };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrací všechny typy dokumentů seřazené dle {@link TypDokument#getNazev()}.
     *
     * @return typy dokumentů
     */
    static findTypyDokumentu() : Promise<TypDokument[]> {
        const uri = serverContextPath + `/api/typy/dokumentu/`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * Konfigurace typu dokumentu. Pokud neexistuje typ dokumentu s předaným kódem, založí ho. Pokud typ dokumentu existuje, vrací uložený záznam.
     *
     * @param kodTypDokument kód typu dokumentu
     * @param nazevDokument název typu dokumentu
     * @return založeny typ dokumentu
     */
    static createTypDokument(kodTypDokument : string, nazevDokument : string) : Promise<TypDokument> {
        const uri = serverContextPath + `/api/typy/dokumentu/create`;
        const headers = undefined;
        const params = { kodTypDokument, nazevDokument };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * Vrací kolekci šablon navázaných na typ dokumentu.
     *
     * @param kodTypDokument 
     * @return šablony navázané na typ dokumentu
     */
    static getSablonyProTypDokumentu(kodTypDokument : string) : Promise<Sablona[]> {
        const uri = serverContextPath + `/api/typy/dokumentu/sablony`;
        const headers = undefined;
        const params = { kodTypDokument };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Dohledání typů dokumentu dle seznamu předaných kódů.
     *
     * @param kodTypDokuments seznam kódů typu dokumentu
     * @return seznam dohledaných typů dokumentu
     */
    static getTypyDokumentu(kodTypDokuments : string[]) : Promise<TypDokument[]> {
        const uri = serverContextPath + `/api/typy/dokumentu/batchRequest`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, kodTypDokuments, headers));
    }

}